import { render } from "./Dalena.vue?vue&type=template&id=2b416d9b&scoped=true"
import script from "./Dalena.vue?vue&type=script&lang=js"
export * from "./Dalena.vue?vue&type=script&lang=js"

import "./Dalena.vue?vue&type=style&index=0&id=2b416d9b&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\natan\\OneDrive\\Code\\Site\\dalena\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b416d9b"]])

export default __exports__